import React from "react";
import DashboardMainContainer from "../../components/common/Containers/DashboardMainContainer";
import { AdminPageTitle } from "../../sections/AdminDashboard/shared/adminUx";
import FollowingLayout from "../../sections/CustomerDashboard/Dashboard/Following/FollowingLayout";
import { CUSTOMER_CENTERED_PAGE_TITLE_CLASS } from "../../sections/CustomerDashboard/shared/customerLayoutSpec";

const Following = () => {
  return (
    <DashboardMainContainer className="lg:px-5 lg:pb-10">
      <AdminPageTitle className={CUSTOMER_CENTERED_PAGE_TITLE_CLASS}>
        Businesses you follow
      </AdminPageTitle>
      <div className="min-h-screen">
        <FollowingLayout />
      </div>
    </DashboardMainContainer>
  );
};

export default Following;
